export const sendMessageToMobile = (type: string, parameters?: any) => {
  if (typeof window?.ReactNativeWebView !== 'undefined') {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: type,
        parameters: parameters,
      }),
    );
  }
};

export const isInWebView = () => {
  return (
    typeof window !== 'undefined' &&
    'ReactNativeWebView' in window &&
    typeof window.ReactNativeWebView !== 'undefined'
  );
};
